(() => {
  'use strict';

  const isHome = () => {
    const root = (window.Shopify?.routes?.root || '/').replace(/\/$/, '');
    return window.location.pathname.replace(/\/$/, '') === root;
  };
  const bySuffix = (suffix) => document.querySelector(`[id$="${suffix}"]`);
  const CATALOG_UI = window.myromyQ4?.catalogUi || {};
  const ui = (key) => String(CATALOG_UI[key] || '');

  const ensureMobileCommerceStyles = () => {
    if (document.getElementById('myromy-mobile-commerce-styles')) return;
    const style = document.createElement('style');
    style.id = 'myromy-mobile-commerce-styles';
    style.textContent = `
      @media screen and (max-width: 699px) {
        [id$="__featured_collection_9ecjDM"] .product-card__quick-buy button,
        [id$="__featured_collection_9ecjDM"] .product-card__quick-buy a {
          min-width: 44px !important;
          min-height: 44px !important;
        }
      }
      @media screen and (min-width: 480px) and (max-width: 699px) {
        [id$="__featured_collection_9ecjDM"] product-list,
        [id$="__featured_collection_9ecjDM"] .product-list {
          --product-list-items-per-row: 3 !important;
        }
        [id$="__featured_collection_9ecjDM"] .product-card__title,
        [id$="__featured_collection_9ecjDM"] price-list {
          font-size: max(13px, .78rem) !important;
          line-height: 1.3 !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const placeHomepageSections = () => {
    if (!isHome()) return;
    const intro = bySuffix('__media_with_text_FbPQrp');
    const testimonialStyles = bySuffix('__custom_liquid_LEjtzy');
    const testimonials = bySuffix('__testimonials_Uj9wfB');
    const amazonReviews = bySuffix('__178758300830fb6907');
    const campaign = bySuffix('__slideshow_RrR4dL');
    const collection = bySuffix('__featured_collection_9ecjDM');
    if (!intro) return;

    const sequence = [testimonialStyles, testimonials, amazonReviews, campaign, collection];

    let anchor = intro;
    sequence.forEach((section) => {
      if (!section) return;
      if (anchor.nextElementSibling !== section) anchor.insertAdjacentElement('afterend', section);
      anchor = section;
    });

    document.documentElement.dataset.myromyHomepageOrder = 'editable-content-source';
  };

  const compactHomeTitle = (handle) => {
    const edition = handle.includes('coffee') ? ui('editionCoffee') : handle.includes('cream') ? ui('editionCream') : ui('editionSignature');
    let base = '';
    if (handle.includes('multi-braeter')) base = ui('titleBraeter');
    else if (handle.includes('brot-frische-topf')) base = ui('titleBrottopf');
    else if (handle.includes('brick')) base = handle.includes('bbq') ? ui('titleBrickBbq') : ui('titleBrickClassic');
    else if (handle.includes('plancha')) base = handle.includes('bbq') ? ui('titlePlanchaBbq') : ui('titlePlanchaClassic');
    return base && edition ? `${base} · ${edition}` : '';
  };

  const shortenHomepageProductTitles = () => {
    if (!isHome()) return;
    const section = bySuffix('__featured_collection_9ecjDM');
    if (!section) return;
    const mobile = window.matchMedia('(max-width: 699px)').matches;

    section.querySelectorAll('product-card[handle]').forEach((card) => {
      const link = card.querySelector('.product-card__title a');
      if (!link) return;
      if (!link.dataset.myromyFullTitle) {
        link.dataset.myromyFullTitle = (link.textContent || '').replace(/\s+/g, ' ').trim();
      }
      const compact = compactHomeTitle(card.getAttribute('handle') || '');
      if (mobile && compact) {
        link.textContent = compact;
        link.setAttribute('aria-label', link.dataset.myromyFullTitle);
      } else {
        link.textContent = link.dataset.myromyFullTitle;
        link.removeAttribute('aria-label');
      }
    });
  };

  const restoreCompactPlanchaGrid = () => {
    if (!isHome()) return;
    const row = document.querySelector('.myromy-home-core__row[data-group="plancha"]');
    const grid = row?.querySelector('.myromy-home-core__grid');
    if (!grid) return;

    const seen = new Set();
    grid.querySelectorAll('product-card[handle]').forEach((card) => {
      const handle = card.getAttribute('handle') || '';
      if (!handle) return;
      if (seen.has(handle)) card.remove();
      else seen.add(handle);
    });
    grid.dataset.count = String(grid.querySelectorAll(':scope > product-card').length);
  };

  const run = () => {
    ensureMobileCommerceStyles();
    placeHomepageSections();
    restoreCompactPlanchaGrid();
    shortenHomepageProductTitles();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
  window.setTimeout(run, 120);
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:select', run);
  window.matchMedia('(max-width: 749px)').addEventListener?.('change', run);
})();
